/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GAMELEAVE_URL } from "../services/apiUrl";
import { useRest, CALL_TYPES } from "../services/rest/api";
import Utility from "../utility/utility";
import { exitGame } from "../redux/actions/joinAction";
import { useLocation } from "react-router-dom";
let roomId = 0

const EndGame = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const gameData = useSelector((state) => state?.joinReducer || null);
  roomId = gameData?.data?.room_id;
  const [resultData, setresultData] = useState([]);
  useEffect(() => {
    Utility.isSignedIn(gameData?.data).then((value) => {
      if (!value) {
        navigate("/home");
      }
    });
  }, [gameData?.data]);

  useEffect(() => {
    let rsltData = []
    for (var i = 0; i < state?.data?.data?.length; i++) {
      let open_count = state?.data?.data?.[i].open_situation.length
      let asset_parsed =  JSON.parse(state?.data?.data?.[i].assets)
      let assets = asset_parsed["Time/Energy"] + asset_parsed["Home/Family"] + asset_parsed["Money/Debt"] + asset_parsed["Work/Job"]
      let name = state?.data?.data?.[i].member_name
      let pendingAssets = assets - open_count
      rsltData.push({ score: pendingAssets, name: name })
    }

    rsltData?.sort((a, b) => (a.score > b.score ? -1 : 1))
    setresultData(rsltData)
  }, [state?.data]);

  useEffect(() => {
    // send a message to the server
    return () => {
      Utility.disconnectSocket()
    }
  }, []);

  const { data, fetchData: LeaveGame } = useRest({
    URL: GAMELEAVE_URL,
    CALL_TYPE: CALL_TYPES.POST,
    PAYLOAD: {
      room_id: JSON.stringify(gameData?.data?.room_id),
      id: JSON.stringify(gameData?.data?.id),
    },
    lazy: true,
  });

  const Leave_game = async () => {
    const socket = await Utility.getConnectedSocket()
    await socket.emit("room_leave", roomId);
    Utility.disconnectSocket()
    await LeaveGame();
  }
  useEffect(() => {
    window.addEventListener('beforeunload', alertUser)
    window.addEventListener('unload', handleTabClosing)
    return () => {
      window.removeEventListener('beforeunload', alertUser)
      window.removeEventListener('unload', handleTabClosing)
    }
  }, [])

  const handleTabClosing = async () => {
    await Leave_game()
  }

  const alertUser = async (event) => {
    event.preventDefault()
    event.returnValue = ''
    await Leave_game()
  }

  useEffect(() => {
    if (data?.status_code === 200) {
      dispatch(exitGame());
    }
  }, [data]);

  // const scoreboardData = scoreboard?.data?.map((item, index) => (

  //   <tr key={index}>
  //     {<th scope="row" className="border-right-color  font-table-head" style={item.member_id === turnMemberId ? { color: "green" } : { color: "black" }}>
  //       {item.member_name}
  //     </th>}
  //     <td>{<RenderEmojis scoreboard_stats={item.open_situation} />}</td>
  //   </tr>
  // ));


  const RenderScorboard = (params) => {
    return resultData?.map((item_stats, index_stats) => (

      <tr>
        <th scope="row" className="Poppins-Bold  font-table-head green-font padding-btn">{index_stats === 0 ? "1st" : index_stats === 1 ? "2nd" : index_stats === 2 ? "3rd" : "4th"}</th>
        <th scope="row" className="border-right-color Poppins-Bold  font-table-head text-center padding-btn">{item_stats.name}</th>
        <td className="border-none Poppins-Bold font-table-heads final-color padding-btn">{item_stats.score}</td>
      </tr>
    ));
  };

  return (
    <>
      <div className="background gameboard-over">
        <div className=" container">
          <div className="col-md-12 mt-5">
            <h1 className="Pacifico-Regulars gane-over-font mb-5">Game Over</h1>
          </div>
          <div className="col-md-12">
            <div className="card w-75 m-auto">
              <div className="text-center">
                <h2 className="mt-4 final-color mb-5"><b>Final Scores</b></h2>
              </div>
              <table className="table mt-5 game-table-widths m-auto">
                <tbody className="mt-5">
                  {<RenderScorboard />}
                </tbody>
              </table>
            </div>
            <div className="text-center">
              <button type="button" onClick={(e) => {
                    Leave_game()
                  }} className="game-over-button">EXIT GAME</button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default EndGame;
